module.exports = __webpack_public_path__ + "static/media/drill.a6042145.png";